import { HttpInterceptorFn } from "@angular/common/http";
import { inject } from "@angular/core";
import { HttpConcurrencyScheduler } from "./http-concurrency-scheduler.service";

export const concurrencyInterceptor: HttpInterceptorFn = (request, next) => {
    const scheduler = inject(HttpConcurrencyScheduler);
    return scheduler.schedule(() => next(request));
};
